<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div>
    <v-dialog
      v-model="revoke_dialog"
      max-width="900"
    >
      <v-card>
        <v-card-title class="headline">
          Cancelar Acceso
          <v-progress-linear v-if="sendig_cancel()" :indeterminate="true" height="2">
          </v-progress-linear>
        </v-card-title>
        <v-alert
          :value="alert"
          dismissible
          :type="alertType"
        >
          {{ alertMessage }}
        </v-alert>
        <v-container grid-list-md>
          <v-form
            ref="revokeForm"
            v-model="cancelValid"
            lazy-validation
          >
            <v-text-field
              label="Motivo"
              placeholder="Motivo Cancelación"
              v-model="motivo_cancelacion"
              :rules="text_required_rules"
            />
          </v-form>
        </v-container>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="revoke_dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="blue darken-1"
            flat="flat"
            @click="send_revoke_form"
          >
            Aceptar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-xs-center">
      <v-dialog
        v-model="dialogoEntrada"
        width="500"
      >
        <v-card>
          <v-card-title class="headline">Registrar Entrada</v-card-title>
          <v-card-text>
            <v-form
              ref="entryForm"
              v-model="validEntry"
              lazy-validation
            >
            <v-combobox
              v-model="portico"
              :items="porticos"
              :search-input.sync="porticoSearch"
              :hide-no-data="!porticoSearch"
              hide-selected
              item-text="nombre"
              item-value="nombre"
              label="Pórtico"
              :rules="text_required_rules"
              placeholder="Comience a escribir para buscar"
              return-object
            >
            </v-combobox>
            <v-text-field
              label="Fecha Entrada"
              placeholder="Fecha Entrada"
              v-model="fecha_esperada"
              readonly
            />
            <v-text-field
              label="Hora Entrada"
              placeholder="Hora Entrada"
              readonly
              v-model="hora_esperada"
            />
            <v-text-field
              label="Observaciones"
              placeholder="Observaciones"
              v-model="observaciones"
            />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="primary"
              flat
              @click="sendEntry"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div class="text-xs-center">
      <v-dialog
        v-model="dialogoSalida"
        width="500"
      >
        <v-card>
          <v-card-title class="headline">Registrar Salida</v-card-title>
          <v-card-text>
            <v-form
              ref="exitForm"
              v-model="validExit"
              lazy-validation
            >
              <v-combobox
                v-model="portico"
                :items="porticos"
                :search-input.sync="porticoSearch"
                :hide-no-data="!porticoSearch"
                hide-selected
                item-text="nombre"
                item-value="nombre"
                label="Pórtico"
                placeholder="Comience a escribir para buscar"
                return-object
              />
              <v-text-field
                label="Fecha Salida"
                placeholder="Fecha Salida"
                v-model="fecha_esperada"
                readonly
              />
              <v-text-field
                label="Hora Salida"
                placeholder="Hora Salida"
                readonly
                v-model="hora_esperada"
              />
              <v-text-field
                label="Observaciones"
                placeholder="Observaciones"
                v-model="observaciones"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="primary"
              flat
              @click="sendExit"
            >
              Enviar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <v-card-title>
      <v-spacer/>
      <v-text-field
        v-model="presearch"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      />
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="rowItems"
      :pagination.sync="pagination"
      :total-items="totalItems"
      :loading="loading"
      :expand="expand"
      :rows-per-page-items="[5,10,25,50]"
      disable-initial-sort
    >
      <template v-slot:items="props">
        <tr>
          <td class="text-xs-left px-2">
            {{ props.item.nombre_operador_walkin }}
          </td>
          <td class="text-xs-left px-2">
            {{ props.item.nombre_operador }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.fecha_esperada }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.vigente_hasta }}
          </td>
          <td v-if="!limitado" @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.desarrollo }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.subcondominio }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.vivienda }}
          </td>
          <td v-if="!limitado" @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.nombre_completo_residente }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.asunto }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.nombres_visitante }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.apellidos_visitante }}
          </td>
          <td @click="props.expanded = !props.expanded" class="text-xs-left px-2">
            {{ props.item.observaciones }}
          </td>
          <td v-if="props.item.qr_code" class="text-xs-center px-0">SI</td>
          <td v-else class="text-xs-center px-0">NO</td>
          <td v-if="props.item.acceso_multiple==true" class="text-xs-center px-0">SI</td>
          <td v-else class="text-xs-center px-0">NO</td>
          <td @click="props.expanded = !props.expanded" class="text-xs-center px-0">
            {{ props.item.ultimo_movimiento }}
          </td>
          <td class="justify-center layout px-0">
            <v-icon v-show="entry_btn === true"
              class="pt-2"
              small
              @click="showEntryDialog(props.item.id)"
            >
              fa-sign-in-alt
            </v-icon>
            <v-icon v-show="exit_btn === true"
              class="pl-2 pt-2"
              small
              @click="showExitDialog(props.item.id)"
            >
              fa-sign-out-alt
            </v-icon>
            <v-icon v-show="revoke_btn === true"
              class="pl-2 pt-2 pr-4"
              small
              @click="show_revoke_form(props.item.id)"
            >
              fa-times
            </v-icon>
          </td>
        </tr>
      </template>
      <template v-slot:expand="props">
        <v-card>
          <v-card-title class="headline">Detalle Acceso</v-card-title>
              <v-card-text>
                <span v-if="props.item.acceso_multiple===true">
                  <strong>TIPO</strong>: Acceso Múltiple <br>
                  <strong>FECHA DE VIGENCIA</strong>:&nbsp;
                  {{ formatter_date_range(props.item.fecha_esperada, props.item.vigente_hasta, 'YYYY-MM-DD') }}
                  <br>
                  <strong>HORARIO PERMITIDO</strong>:&nbsp;
                  <span v-if="props.item.acceso_todo_dia==true">Todo el día</span>
                  <span v-else>
                    {{ formatter_time_range(props.item.hora_desde, props.item.hora_hasta) }}
                  </span>
                  <br>
                  <strong>DÍAS PERMITIDOS</strong>: <br>
                  <span>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.lunes==true">
                      Lunes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.martes==true">
                      Martes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.miercoles==true">
                      Miércoles
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.jueves==true">
                      Jueves
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.viernes==true">
                      Viernes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.sabado==true">
                      Sábado
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.domingo==true">
                      Domingo
                    </v-chip>
                  </span>
                  <br>
                </span>
                <span v-else>
                  <strong>TIPO</strong>: Acceso Único<br>
                  <strong>FECHA ESPERADA</strong>:&nbsp;
                  {{ props.item.fecha_esperada }}
                  <br>
                  <strong>VIGENTE HASTA</strong>:&nbsp;
                  {{ props.item.vigente_hasta }}
                  <br>
                </span>
              </v-card-text>
        </v-card>
        <v-timeline>
          <v-timeline-item
            v-for="n in props.item.detalles"
            :key="n.id"
            color="red lighten-2"
            small
          >
            <v-card>
              <v-card-title class="headline">{{n.fecha}}</v-card-title>
              <v-card-text>
                <span v-if="props.item.acceso_multiple===true">
                  <strong>TIPO</strong>: Acceso Múltiple <br>
                  <strong>FECHA DE VIGENCIA</strong>:&nbsp;
                  {{ formatter_date_range(props.item.fecha_esperada, props.item.vigente_hasta, 'YYYY-MM-DD') }}
                  <br>
                  <strong>HORARIO PERMITIDO</strong>:&nbsp;
                  <span v-if="props.item.acceso_todo_dia==true">Todo el día</span>
                  <span v-else>
                    {{ formatter_time_range(props.item.hora_desde, props.item.hora_hasta) }}
                  </span>
                  <br>
                  <strong>DÍAS PERMITIDOS</strong>: <br>
                  <span>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.lunes==true">
                      Lunes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.martes==true">
                      Martes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.miercoles==true">
                      Miércoles
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.jueves==true">
                      Jueves
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.viernes==true">
                      Viernes
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.sabado==true">
                      Sábado
                    </v-chip>
                    <v-chip small disabled outline color="secondary"
                            v-show="props.item.domingo==true">
                      Domingo
                    </v-chip>
                  </span>
                  <br>
                </span>
                <span v-else>
                  <strong>TIPO</strong>: Acceso Único<br>
                  <strong>FECHA ESPERADA</strong>:&nbsp;
                  {{ props.item.fecha_esperada }}
                  <br>
                  <strong>VIGENTE HASTA</strong>:&nbsp;
                  {{ props.item.vigente_hasta }}
                  <br>
                </span>
                <strong>PORTICO</strong>: {{n.portico}}
                <br>
                <strong>ESTATUS</strong>: {{n.status_acceso}}
                <br>
                <strong>OBSERVACIONES</strong>: {{n.observaciones}}
                <br>
                <v-btn v-show="images_btn === true" flat icon @click="get_acceso_detalles(props.item, n.id)">
                  <v-icon>description</v-icon>
                </v-btn>
              </v-card-text>
            </v-card>
          </v-timeline-item>
        </v-timeline>
      </template>
    </v-data-table>
    <v-dialog
      v-model="dialogDetalles"
      persistent
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="py-0 subheading" dark color="primary">
          TIPO:&nbsp;ACCESO&nbsp;
          <span v-if="acceso.acceso_multiple===true">MÚLTIPLE</span><span v-else>ÚNICO</span>
          <v-spacer></v-spacer>
          <v-btn flat icon
                 @click="close_dialog_detalles()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-container grid-list-md fluid>
          <v-layout row wrap>
            <template v-if="acceso.acceso_multiple===true">
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="formatter_date_range(acceso.fecha_esperada, acceso.vigente_hasta, 'YYYY-MM-DD')"
                  label="Fecha de Vigencia"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  v-if="acceso.acceso_todo_dia==true"
                  value="Todo el día"
                  label="Horario Permitido"
                  readonly
                />
                <v-text-field
                  v-else
                  :value="formatter_time_range(acceso.hora_desde, acceso.hora_hasta)"
                  label="Horario Permitido"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  :value="formatter_dias_vigencia(acceso)"
                  label="Días Permitidos"
                  readonly
                />
              </v-flex>
            </template>
            <template v-else>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="acceso.fecha_esperada"
                  label="Fecha Esperada"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm3 md3>
                <v-text-field
                  :value="acceso.vigente_hasta"
                  label="Vigente Hasta"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  readonly
                />
              </v-flex>
            </template>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.fecha"
                label="Fecha de Movimiento"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.portico"
                label="Portico"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md2>
              <v-text-field
                v-model="accesos_detalles.status_acceso"
                label="Estatus"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm3 md6>
              <v-text-field
                v-model="accesos_detalles.observaciones"
                label="Observaciones"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.desarrollo"
                label="Condominio"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.subcondominio"
                label="Sub Condominio"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm4 md4>
              <v-text-field
                v-model="acceso.vivienda"
                label="Vivienda"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm12 md12>
              <strong>Datos Personales del Contacto</strong>
              <v-divider/>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="acceso.nombres_residente"
                label="Nombre(s)"
                readonly
              />
            </v-flex>
            <v-flex xs12 sm6 md6>
              <v-text-field
                v-model="acceso.apellidos_residente"
                label="Apellidos"
                readonly
              />
            </v-flex>
          </v-layout>
          <template
            v-if="accesos_detalles.visitantes &&
                          accesos_detalles.visitantes.length > 0">
            <v-layout row wrap
                      v-for="(visitante, index) in accesos_detalles.visitantes"
                      :key="index">
              <v-flex xs12 sm12 md12>
                <strong>
                  Datos Personales del Visitante No. {{ index + 1 }}
                </strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="visitante.tipo"
                  label="Tipo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  v-model="visitante.empresa"
                  label="Empresa"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.motivo"
                  label="Motivo"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.nombres"
                  label="Nombre(s)"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm6 md6>
                <v-text-field
                  v-model="visitante.apellidos"
                  label="Apellidos"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_rostro!==''">
                <img :src="decode_base64(visitante.foto_rostro)"
                     style="width: 95%"
                     alt="foto_rostro"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_frente!==''">
                <img :src="decode_base64(visitante.foto_credencial_frente)"
                     style="width: 95%"
                     alt="foto_credencial_frente"/>
              </v-flex>
              <v-flex xs12 sm4 md4 v-show="visitante.foto_credencial_trasera!==''">
                <img :src="decode_base64(visitante.foto_credencial_trasera)"
                     style="width: 95%"
                     alt="foto_credencial_trasera"/>
              </v-flex>
            </v-layout>
          </template>
          <template v-else>
            <v-layout row wrap>
              <v-flex xs12 sm12 md12 class="text-md-left">
                <strong>Datos Personales del Visitante</strong>
                <v-divider/>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  v-model="acceso.asunto"
                  label="Asunto"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field
                  v-model="acceso.nombres_visitante"
                  label="Nombre(s)"
                  readonly
                />
              </v-flex>
              <v-flex xs12 sm5 md5>
                <v-text-field
                  v-model="acceso.apellidos_visitante"
                  label="Apellidos"
                  readonly
                />
              </v-flex>
            </v-layout>
          </template>
          <template v-show="accesos_detalles.vehiculos">
            <template v-for="(vehiculo, index) in accesos_detalles.vehiculos">
              <v-layout row wrap :key="index">
                <v-flex xs12 sm12 md12 class="text-md-left">
                  <strong>Datos del Vehículo No. {{ index + 1 }}</strong>
                  <v-divider/>
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.placas"
                    label="Placas"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.color"
                    label="Color"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.marca"
                    label="Marca"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm3 md3>
                  <v-text-field
                    v-model="vehiculo.modelo"
                    label="Modelo"
                    readonly
                  />
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_frontal!==''">
                  <img :src="decode_base64(vehiculo.foto_frontal)"
                       style="width: 95%"
                       alt="foto_frontal"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_lateral!==''">
                  <img :src="decode_base64(vehiculo.foto_lateral)"
                       style="width: 95%"
                       alt="foto_lateral"/>
                </v-flex>
                <v-flex xs12 sm4 md4 v-show="vehiculo.foto_trasera!==''">
                  <img :src="decode_base64(vehiculo.foto_trasera)"
                       style="width: 95%"
                       alt="foto_trasera"/>
                </v-flex>
              </v-layout>
            </template>
          </template>
          <v-layout row wrap
                    v-show="accesos_detalles.imagenes &&
                                  accesos_detalles.imagenes.length > 0">
            <v-flex xs12 sm12 md12 class="text-md-left">
              <strong>Imágenes</strong>
              <v-divider/>
            </v-flex>
            <v-flex xs12 sm4 md4
                    v-for="(item,i) in accesos_detalles.imagenes"
                    :key="i">
              <img :src="decode_base64(item.image)"
                   style="width: 95%"/>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { getJWTData } from '../common/jwt.service';
import moment from '../../node_modules/moment';

export default {
  data: () => ({
    text_required_rules: [
      v => !!v || 'Requerido',
    ],
    timer: '',
    cancelValid: false,
    access_to_revoke: null,
    revoke_dialog: false,
    motivo_cancelacion: null,
    presearch: '',
    searchTimer: null,
    validEntry: false,
    validExit: false,
    accesoId: null,
    porticos: [{ nombre: 'PRINCIPAL' }, { nombre: 'PROVEEDORES' }],
    portico: null,
    observaciones: '',
    porticoSearch: null,
    fecha_esperada: null,
    status_acceso: null,
    hora_esperada: null,
    loading: true,
    totalItems: 0,
    rowItems: [],
    search: '',
    pagination: {},
    expand: false,
    dialogoEntrada: false,
    dialogoSalida: false,
    dialog: false,
    dialogTest: false,
    dialogDetalles: false,
    acceso: [],
    images_btn: false,
    entry_btn: false,
    exit_btn: false,
    revoke_btn: false,
    normal_headers: [
      {
        text: 'Solicitud De Acceso', value: 'nombre_operador_walkin', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Autorizacion De Acceso', value: 'nombre_operador', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Fecha Esperada', value: 'fecha_esperada', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Vigente Hasta', value: 'fecha_esperada', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Condominio', value: 'desarrollo', sortable: true, class: 'px-2',
      },
      {
        text: 'Sub Condominio', value: 'subcondominio', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Vivienda', value: 'vivienda', sortable: true, width: '50px', class: 'px-2',
      },
      {
        text: 'Residente', value: 'nombre_completo_residente', sortable: true, class: 'px-2',
      },
      {
        text: 'Asunto', value: 'asunto', sortable: true, class: 'px-2',
      },
      {
        text: 'Nombre Visitante', value: 'nombres_visitante', sortable: true, class: 'px-2',
      },
      {
        text: 'Apellidos Visitante', value: 'apellidos_visitante', sortable: true, class: 'px-2',
      },
      {
        text: 'Observaciones', value: 'observaciones', sortable: true, class: 'px-2',
      },
      {
        text: 'Con QR', value: 'qr_code', sortable: true, class: 'px-0',
      },
      {
        text: 'Acceso Múltiple', value: 'acceso_multiple', sortable: true, class: 'px-0',
      },
      {
        text: 'Último Evento', value: 'ultimo_movimiento', sortable: true, width: '50px', class: 'px-0',
      },
      {
        text: 'Acciones', value: 'name', sortable: false, class: 'px-0',
      },
    ],
    limited_headers: [
      {
        text: 'Nombre Operador', value: 'nombre_operador', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Fecha Esperada', value: 'fecha_esperada', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Vigente Hasta', value: 'fecha_esperada', sortable: true, width: '100px', class: 'px-2',
      },
      {
        text: 'Sub Condominio', value: 'subcondominio', sortable: true, width: '50px',
      },
      {
        text: 'Vivienda', value: 'vivienda', sortable: true, width: '50px',
      },
      {
        text: 'Asunto', value: 'asunto', sortable: true,
      },
      {
        text: 'Nombre Visitante', value: 'nombres_visitante', sortable: true,
      },
      {
        text: 'Apellidos Visitante', value: 'apellidos_visitante', sortable: true,
      },
      {
        text: 'Observaciones', value: 'observaciones', sortable: true,
      },
      {
        text: 'Último Evento', value: 'ultimo_movimiento', sortable: true, width: '50px',
      },
      {
        text: 'Acciones', value: 'name', sortable: false,
      },
    ],
  }),
  computed: {
    folios() {
      return this.$store.getters.accesos_list;
    },
    revoke_sent() {
      return this.$store.getters.revoke_sent;
    },
    alertType() {
      return this.$store.getters.revoke_alertType;
    },
    alertMessage() {
      return this.$store.getters.revoke_alertMessage;
    },
    alert() {
      return this.$store.getters.revoke_alert;
    },
    headers() {
      const data = getJWTData();
      if (data.user_claims.limitado) {
        return this.limited_headers;
      }
      return this.normal_headers;
    },
    limitado() {
      const data = getJWTData();
      return data.user_claims.limitado;
    },
    accesos_detalles() {
      return this.$store.getters.accesos_detalles;
    },
    getted_detalles() {
      return this.$store.getters.getted_detalles;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getDataFromApi()
          .then((data) => {
            this.rowItems = data.items;
            this.totalItems = data.total;
          });
      },
      deep: true,
    },
    search() {
      this.getDataFromApi()
        .then((data) => {
          this.rowItems = data.items;
          this.totalItems = data.total;
        });
    },
    presearch() {
      this.cancelSearchTimer();
      this.searchTimer = setInterval(this.updateSearch, 1000);
    },
    revoke_sent() {
      this.reset_revoke_form();
    },
    getted_detalles(val) {
      this.dialogDetalles = val;
    },
  },
  beforeDestroy() {
    this.cancelAutoUpdate();
    this.cancelSearchTimer();
  },
  created() {
    this.user_login_role = getJWTData().user_claims.role;
    if (['admin', 'jefe_monitoristas', 'monitoristas'].includes(this.user_login_role)) {
      if (['admin', 'jefe_monitoristas'].includes(this.user_login_role)) {
        this.entry_btn = true;
        this.exit_btn = true;
        this.revoke_btn = true;
        this.images_btn = true;
      } else if (['monitoristas'].includes(this.user_login_role)) {
        this.images_btn = true;
      }
    }
    /* if (!(this.$store.getters.accesos_list.length > 0)) {
      this.$store.dispatch('clearAccesosAction');
      this.getDataFromApi();
    } else {
      this.$store.commit('fetchedAccesos');
    } */
    this.timer = setInterval(this.fetchEventsList, 60000);
  },
  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {
          sortBy, descending, page, rowsPerPage,
        } = this.pagination;

        const formdata = {
          page,
          per_page: rowsPerPage,
          search: this.search,
          order_by: sortBy,
          descending,
        };
        this.$store.dispatch('fetchAccesos', formdata)
          .then(() => {
            this.loading = false;
            const items = this.$store.getters.accesos_list;
            const total = this.$store.getters.accesos_total;

            this.$store.commit('fetchedAccesos');
            resolve({
              items,
              total,
            });
          });
      });
    },
    show_revoke_form(accessId) {
      this.$refs.revokeForm.reset();
      this.access_to_revoke = accessId;
      this.revoke_dialog = true;
    },
    send_revoke_form() {
      if (this.$refs.revokeForm.validate()) {
        const data = { accesoId: this.access_to_revoke, motivo: this.motivo_cancelacion };
        this.$store.dispatch('cancelAccesoAction', data);
      }
    },
    reset_revoke_form() {
      this.$refs.revokeForm.reset();
      this.access_to_revoke = null;
      this.revoke_dialog = false;
    },
    sendig_cancel() {
      return this.$store.getters.sending_revoke;
    },
    updateSearch() {
      if (this.presearch !== this.search) {
        this.search = this.presearch;
      }
    },
    fetchEventsList() {
      if (!this.$store.getters.loading_accesos) {
        this.$store.dispatch('clearAccesosAction');
        this.getDataFromApi();
      }
    },
    showEntryDialog(accesoId) {
      this.set_initial_date();
      this.observaciones = '';
      this.portico = null;
      this.porticoSearch = null;
      this.dialogoEntrada = true;
      this.status_acceso = 'CUMPLIDO';
      this.accesoId = accesoId;
    },
    showExitDialog(accesoId) {
      this.set_initial_date();
      this.observaciones = '';
      this.portico = null;
      this.porticoSearch = null;
      this.dialogoSalida = true;
      this.status_acceso = 'SALIDA';
      this.accesoId = accesoId;
    },
    sendAccesoDetail() {
      const data = {
        portico: this.portico.nombre,
        // portico: 'PRINCIPAL',
        observaciones: this.observaciones,
        status_acceso: this.status_acceso,
        fecha_detalle: this.fecha_esperada,
        hora_detalle: this.hora_esperada,
        operador_id: getJWTData().user_claims.id,
        acceso_id: this.accesoId,
      };
      this.$store.dispatch('sendEntry', data);
    },
    sendEntry() {
      if (this.$refs.entryForm.validate()) {
        this.sendAccesoDetail();
        this.$refs.entryForm.resetValidation();
        this.dialogoEntrada = false;
      }
    },
    sendExit() {
      if (this.$refs.exitForm.validate()) {
        this.sendAccesoDetail();
        this.$refs.exitForm.resetValidation();
        this.dialogoSalida = false;
      }
    },
    cancelAutoUpdate() { clearInterval(this.timer); },
    cancelSearchTimer() {
      if (this.searchTimer !== null) {
        clearInterval(this.searchTimer);
      }
    },
    set_initial_date() {
      const currentTime = new Date();
      const mm = currentTime.getMonth() + 1; // getMonth() is zero-based
      const dd = currentTime.getDate();
      const hh = currentTime.getHours();
      const min = currentTime.getMinutes();
      const dateArray = [currentTime.getFullYear(), (mm > 9 ? '' : '0') + mm, (dd > 9 ? '' : '0') + dd];
      this.fecha_esperada = dateArray.join('-');
      const hourArray = [(hh > 9 ? '' : '0') + hh, (min > 9 ? '' : '0') + min];
      this.hora_esperada = hourArray.join(':');
    },
    decode_base64(encoded) {
      const base = 'data:image/jpeg;base64, ';
      if (encoded !== null) {
        return base.concat(encoded);
      }
      return null;
    },
    get_acceso_detalles(value, detalleId) {
      this.acceso = value;
      this.$store.dispatch('fetchAccesoDetalles', detalleId);
    },
    close_dialog_detalles() {
      this.acceso = [];
      this.$store.commit('clearAccesosDetalles');
    },
    formatter_date(fecha, formato = 'DD-MM-YYYY') {
      return moment(fecha).format(formato);
    },
    formatter_time(hora, formato = 'HH:mm') {
      return moment(hora, 'HH:mm:ss').format(formato);
    },
    formatter_date_range(desde, hasta, formato = 'DD-MM-YYYY') {
      return `${this.formatter_date(desde, formato)} al ${this.formatter_date(hasta, formato)}`;
    },
    formatter_time_range(desde, hasta, formato = 'HH:mm') {
      return `${this.formatter_time(desde, formato)} a ${this.formatter_time(hasta, formato)}`;
    },
    formatter_dias_vigencia(acceso) {
      let html = '';
      if (acceso.lunes === true) {
        html += 'Lunes ';
      }
      if (acceso.martes === true) {
        html += 'Martes ';
      }
      if (acceso.miercoles === true) {
        html += 'Miércoles ';
      }
      if (acceso.jueves === true) {
        html += 'Jueves ';
      }
      if (acceso.viernes === true) {
        html += 'Viernes ';
      }
      if (acceso.sabado === true) {
        html += 'Sábado ';
      }
      if (acceso.domingo === true) {
        html += 'Domingo ';
      }
      return html;
    },
  },
};
</script>
